import React from 'react';
import { themr } from 'react-css-themr';
import { ButtonWithPopover, ButtonTypes } from 'common/components/core/button';
import { PopoverPlaceEnum } from 'common/components/core/popover/popOverFactory';
import classnames from 'classnames';
import defaultTheme from './PopOverMenu.scss';

/*Future we need to migrate this to neo as of now it is small port and theme will break*/
const Menu = React.memo(({ options, theme, onMenuItemClick }) => {
    return (
        <div className={theme.menuInner}>
            {options.map(option => (
                <MenuOption
                    option={option}
                    key={option.id}
                    onMenuItemClick={onMenuItemClick}
                    theme={theme}
                />
            ))}
        </div>
    );
});

class MenuOption extends React.PureComponent {
    handelOptionClick = event => {
        const { onMenuItemClick, option } = this.props;
        onMenuItemClick?.(event, option);
    };

    render() {
        const { option, theme } = this.props;
        if (option.isTitle) {
            return (
                <div className={theme.menuTitle}>
                    <span className={theme.text}>{option.label}</span>
                </div>
            );
        }
        if (option.isEmptyState) {
            return (
                <div className={theme.emptyState}>{option.emptyStateText}</div>
            );
        }
        const isOptionDisabled =
            typeof option.isDisabled === 'function'
                ? option.isDisabled()
                : option.isDisabled;

        return (
            <div
                className={classnames(theme.menuItem, {
                    [theme.disabled]: isOptionDisabled
                })}
                onClick={this.handelOptionClick}
                data-test-id={option.id}
            >
                <span className={theme.caption}>{option.label}</span>
            </div>
        );
    }
}

class PopOverMenu extends React.PureComponent {
    static defaultProps = {
        icon: 'ellipsis_v'
    };

    state = {
        isOpen: false
    };
    buttonWithPopover;

    onPopoverLoad = button => {
        this.buttonWithPopover = button;
    };

    hidePopOver = () => {
        this.setState({
            isOpen: false
        });
    };

    onClick = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    };

    onMenuItemClick = (event, { onClick, ...rest }) => {
        const isDisabled =
            typeof rest.isDisabled === 'function'
                ? rest.isDisabled()
                : rest.isDisabled;
        if (!isDisabled) {
            onClick?.(event, { ...rest, isDisabled });
            this.hidePopOver();
        }
    };

    renderMenu = () => {
        const { menu, theme } = this.props;
        return (
            <Menu
                options={menu}
                theme={theme}
                onMenuItemClick={this.onMenuItemClick}
            />
        );
    };

    render() {
        const { theme, disabled, disableArrow, icon } = this.props;
        const { isOpen } = this.state;
        return (
            <ButtonWithPopover
                ref={this.onPopoverLoad}
                theme={theme}
                invertPopover={false}
                popOverContent={this.renderMenu}
                isPopOverOpen={isOpen}
                hidePopoverOnClick
                place={PopoverPlaceEnum.Below}
                icon={icon}
                onClick={this.onClick}
                disabled={disabled}
                disableArrow={disableArrow}
                onOuterAction={this.hidePopOver}
                buttonType={ButtonTypes.Icon}
                className={theme.popoverMenuBtn}
            />
        );
    }
}

const ThemedPopOverMenu = themr('PopOverMenu', defaultTheme)(PopOverMenu);

export { ThemedPopOverMenu as PopOverMenu };
export default ThemedPopOverMenu;
